const NAV_OFFSET = 72;

export const scrollToId = (id) => {
  if (id === "home") return scrollToTop();
  const el = document.getElementById(id);
  if (!el) return false;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -NAV_OFFSET, duration: 1.2 });
  else window.scrollTo({ top: el.getBoundingClientRect().top + window.scrollY - NAV_OFFSET, behavior: "smooth" });
  return true;
};

export const scrollToTop = () => {
  if (window.__lenis) window.__lenis.scrollTo(0, { duration: 1.2 });
  else window.scrollTo({ top: 0, behavior: "smooth" });
  return true;
};

export const scrollBy = (dir) => {
  const amount = window.innerHeight * 0.8 * dir;
  if (window.__lenis) window.__lenis.scrollTo(window.scrollY + amount, { duration: 0.9 });
  else window.scrollBy({ top: amount, behavior: "smooth" });
};
